import { Inbox } from 'lucide-react';

export function EmptyState({ icon: Icon = Inbox, title, description, action }) {
  return (
    <div className="empty">
      <div className="empty-icon"><Icon size={48} /></div>
      <h3 style={{ margin: '6px 0 4px', fontSize: 16, color: 'var(--c-text)' }}>{title}</h3>
      {description && <p style={{ margin: '0 auto', maxWidth: 360 }}>{description}</p>}
      {action && <div style={{ marginTop: 16 }}>{action}</div>}
    </div>
  );
}
